import { z } from 'zod'
import { oc } from '@orpc/contract'
import { facilityDiscoveryAdoptInputSchema } from './facility-discovery-adopt.contract'

// Adds an adopted facility to the practice's Frequently used list. Runs after adopt,
// so the organization id and the fax the order will be sent to are both known —
// a favorite without a fax could never be ordered from.
const adoptShape = facilityDiscoveryAdoptInputSchema.shape

// Both ids reach FHIR searches, where ',' means OR: Google place ids are URL-safe,
// a legacy facility's is 'org:' + its FHIR id, and FHIR ids are letters, digits and
// '-', so nothing else may reach them.
export const facilityDiscoveryRememberInputSchema = z.object({
  placeId: z.string().regex(/^(org:)?[A-Za-z0-9_-]{1,300}$/),
  organizationId: z.string().regex(/^[A-Za-z0-9-]{1,64}$/),
  fax: adoptShape.fax.unwrap(),
})

export const facilityDiscoveryRemember = oc
  .route({ method: 'POST', path: '/v2/facility-discovery/remember' })
  .input(facilityDiscoveryRememberInputSchema)
  .output(z.object({ placeId: z.string() }))
